/*    
<summary>
  This functional component "ClientFilterForm" provides form to get data based on filter
  Developer:Aashish Singh, Created Date:20-March-2024
</summary>
<returns>Returns JSX</returns>
*/
import { Field, Form, Formik, useFormikContext } from "formik";
import React, { useState } from "react";
import { Button, Modal } from "react-bootstrap";
import { FormattedMessage } from "react-intl";
import FormLoader from "../../../../shared-components/FormLoader/FormLoader";
import FormikFormInput from "../../../../shared-components/FormikFormHandlers/FormikFormInput";
import {
  CustomerLoginValidateSchema,
  SendPasswordResetLinkValidationSchema,
} from "../../../../shared-components/FormikFormHandlers/FormikValidationSchema";
import { ShowHidePasswordButton } from "../../../../shared-components/Grid/custom-grid-formatter";
import LoaderButton from "../../../../shared-components/button/loader-button";
import Label from "../../../../shared-components/label/label";
import "./login-walk-in-customer-account-form.css";
import { formatMessage } from "../../../../translations/format-message";
import { on } from "events";

interface IProps {
  submitHandler: (values: any) => void;
  submitResetLinkForm: (values: any) => void;
  onModalClosed: () => void;
  onPasswordResetClosed: () => void;
  actionInProgress: boolean;
  changeForm: (formNo: any) => void;
  initialValues: any;
  isResetPasswordAuthLinkGenerated: boolean;
}

const LoginWalkInCustomerAccountForm = (props: IProps) => {
  const { submitHandler, onModalClosed, initialValues, actionInProgress } =
    props;
  const [showHidePassword, setShowHidePassword] = useState(false);
  const [isResetPasswordFormActive, setIsResetPasswordFormActive] =
    useState(false);

  const FormObserver: React.FC = () => {
    const { values } = useFormikContext<any>();
    return null;
  };

  const activatePasswordResetForm = () => {
    setIsResetPasswordFormActive(true);
  };

  return (
    <>
      <Modal className="add-user-modal filter-from " show={true} centered>
        <Modal.Header>
          <Modal.Title>
            {isResetPasswordFormActive ? (
              <FormattedMessage id="reset_password" />
            ) : (
              <FormattedMessage id="verify_customer" />
            )}
          </Modal.Title>
          <div
            onClick={
              isResetPasswordFormActive
                ? props.onPasswordResetClosed
                : onModalClosed
            }
            className="Crossicons"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="23"
              height="23"
              fill="currentColor"
              className="bi bi-x"
              viewBox="0 0 16 16"
            >
              <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z" />
            </svg>
          </div>
        </Modal.Header>
        {isResetPasswordFormActive ? (
          <Formik
            initialValues={{ Email: "" }}
            enableReinitialize
            validationSchema={SendPasswordResetLinkValidationSchema}
            validateOnBlur={false}
            onSubmit={async (values) => {
              props.submitResetLinkForm(values);
            }}
          >
            <Form className="user-form">
              <Modal.Body>
                <div className="form-group mb-3 row">
                  {props.isResetPasswordAuthLinkGenerated == true 
                  ?
                  <p className="text-center px-2 py-2">
                    <FormattedMessage id="password_reset_link_sent" />
                  </p>
                  :
                  <div className="col-sm-12 form-group">
                    <Label
                      required={true}
                      label="user_label_login_id"
                      htmlFor="email"
                    />
                    <Field
                      data-testid="testUsername"
                      className="form-control"
                      name="Email"
                      type="text"
                      invalidcharacter={[" "]}
                      placeholder="user_label_login_id"
                      validcharacter={[
                        "-",
                        "_",
                        "[",
                        "]",
                        "(",
                        ")",
                        ":",
                        "#",
                        "@",
                        ".",
                      ]}
                      as={FormikFormInput}
                    />
                  </div>
                  }
                </div>
                {}
              </Modal.Body>
              <div className="modal-footer d-flex align-items-center justify-content-center gap-0 border-0">
                {/* <Button
                    variant="btn btn-outline-primary"
                    onClick={() => props.changeForm(2)}
                  >
                    <FormattedMessage id="continue_without_login" />
                  </Button>
                  <Button
                    variant="btn btn-secondary"
                    onClick={() => props.changeForm(3)}
                  >
                    <FormattedMessage id="register_customer" />
                  </Button> */}

                  {
                    props.isResetPasswordAuthLinkGenerated == true
                    ?
                                    <Button
                  variant="outline-success"
                  type="button"
                  onClick={props.onPasswordResetClosed}
                  // disabled={props.addUpdateStoreManagementLoading}
                >
                  {/* <i className="bi bi-x-lg me-1"></i> */}
                  <FormattedMessage id="ok" />
                </Button> :
                <React.Fragment>
                  <Button
                    variant="outline-danger"
                    type="button"
                    onClick={props.onPasswordResetClosed}
                    // disabled={props.addUpdateStoreManagementLoading}
                  >
                    <i className="bi bi-x-lg me-1"></i>
                    <FormattedMessage id="cancel" />
                  </Button>
                  <LoaderButton
                    type="submit"
                    isLoading={actionInProgress}
                    disabled={actionInProgress}
                    text={"send_reset_link"}
                  />

                </React.Fragment>
                  }
              </div>
            </Form>
          </Formik>
        ) : (
          <Formik
            initialValues={initialValues}
            enableReinitialize
            validationSchema={CustomerLoginValidateSchema}
            onSubmit={async (values: any) => {
              submitHandler(values);
            }}
          >
            {({ values }) => (
              <Form className="user-form" noValidate>
                {actionInProgress && <FormLoader loading={actionInProgress} />}
                <FormObserver />
                <Modal.Body>
                  <div className="form-group mb-3 row">
                    <div className="col-sm-12 form-group">
                      <Label
                        required={true}
                        label="user_label_login_id"
                        htmlFor="email"
                      />
                      <Field
                        data-testid="testUsername"
                        className="form-control"
                        name="email"
                        type="text"
                        invalidcharacter={[" "]}
                        placeholder="user_label_login_id"
                        validcharacter={[
                          "-",
                          "_",
                          "[",
                          "]",
                          "(",
                          ")",
                          ":",
                          "#",
                          "@",
                          ".",
                        ]}
                        as={FormikFormInput}
                      />
                    </div>
                    <div className="col-sm-12 position-relative">
                      <Label
                        required={true}
                        label="user_label_password"
                        htmlFor="password"
                      />
                      <div className="form-group">
                        <Field
                          className="form-control "
                          name="password"
                          autoComplete="new-password"
                          type={showHidePassword ? "text" : "password"}
                          placeholder="password"
                          invalidcharacter={[" "]}
                          validcharacter={[
                            "~",
                            "`",
                            "!",
                            "@",
                            "#",
                            "$",
                            "%",
                            "^",
                            "&",
                            "*",
                            "(",
                            ")",
                            "_",
                            "-",
                            "+",
                            "=",
                            "{",
                            "[",
                            "}",
                            "]",
                            "|",
                            "\\",
                            ":",
                            ";",
                            "'",
                            '"',
                            "<",
                            ",",
                            ">",
                            ".",
                            "?",
                            "/",
                          ]}
                          as={FormikFormInput}
                        />
                        <ShowHidePasswordButton
                          showHidePassword={showHidePassword}
                          setShowHidePassword={setShowHidePassword}
                        />
                      </div>
                    </div>
                    <div className="d-flex align-items-center justify-content-between">
                      {/* <div className="checkbox loginCheckbox">
                                  <label className="withlabel-checkbox1">
                                    <Field
                                      data-testid="testRememberMe"
                                      className="form-control"
                                      name="rememberMe"
                                      type="checkbox"
                                      id="inlineFormCheck"
                                      as={FormikFormCheckBox}
                                    />
                                    <span className="cr">
                                      <i className="cr-icon fas fa-check"></i>
                                    </span>
                                  </label>
                                  <h4 className="remember">
                                    <FormattedMessage id="remember_me" />
                                  </h4>
                                </div> */}

                      <button
                        type="button"
                        onClick={activatePasswordResetForm}
                        className="btn text-end p-0 text-primary btn-link"
                      >
                        <FormattedMessage id="forget_password" />
                      </button>
                    </div>
                  </div>
                </Modal.Body>
                <div className="modal-footer d-flex align-items-center justify-content-center gap-0 border-0">
                  <Button
                    variant="btn btn-outline-primary"
                    onClick={() => props.changeForm(2)}
                  >
                    <FormattedMessage id="continue_without_login" />
                  </Button>
                  <Button
                    variant="btn btn-secondary"
                    onClick={() => props.changeForm(3)}
                  >
                    <FormattedMessage id="register_customer" />
                  </Button>
                  <LoaderButton
                    type="submit"
                    isLoading={actionInProgress}
                    disabled={actionInProgress}
                    text={"verify_book"}
                  />
                </div>
              </Form>
            )}
          </Formik>
        )}
      </Modal>
    </>
  );
};

export default LoginWalkInCustomerAccountForm;
